export const INPUT_TYPES = Object.freeze({
	Text: { htmlType: 'text', regex: /^[A-Za-z' \-]+$/ },
	RadioButton: { htmlType: 'radio' },
	TextArea: { htmlType: 'textarea' },
	TextNumber: { htmlType: 'number', regex: /^[0-9\-]+$/ },
	LettersOnly: { htmlType: 'text', regex: /^[A-Za-z]+$/ },
	Email: { htmlType: 'email', regex: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/ },
	CheckBox: { htmlType: 'checkbox' },
	Passport: { htmlType: 'text', regex: /^[A-Za-z0-9]{1,15}$/ },
	LettersAndNumbers: { htmlType: 'text', regex: /^[A-Za-z0-9 ]+$/ },
	PASSWORD_STRENGTH: { htmlType: 'text', regex: /^(?=.*[A-Za-z]).{8}$/ },
});

export const FILE_TYPES = Object.freeze({
	PPT: 1,
	PDF: 2,
	VIDEO: 3,
	AUDIO: 4,
	1: 'PPT',
	2: 'PDF',
	3: 'VIDEO',
	4: 'AUDIO',
});

export const BOOL_VALUES = Object.freeze({
	True: 'true',
	False: 'false',
});

export const ROLES = Object.freeze({
	Admin: 1,
	Student: 2,
	Teacher: 3,
	Coordinator: 4,
	TeacherTeamLeader: 5,
	1: 'Admin',
	2: 'Student',
	3: 'Teacher',
	4: 'Coordinator',
	5: 'Teacher Team Leader',
});

export const MEETING_TYPES = Object.freeze({
	USER_COURSE_CLASS_MEETINGS: 1,
	USER_MEETINGS: 2,
	TEACHER_COURSE_CLASS_MEETINGS: 3,
	TEACHER_MEETINGS: 4,
});

export const MEETING_STATUS = Object.freeze({
	Arrived: 1,
	Not_Arrived: 2,
	1: 'Arrived',
	2: 'Not_Arrived',
});

export const COURSE_TYPES = Object.freeze({
	INTERNAL: 1,
	ESL: 2,
	IELTS: 3,
	IELTS_GENERAL: 4,
	TEF: 5,
	TOFEL: 6,
});

export const NOTIFICATION_TYPES = Object.freeze({
	ERROR: 'error',
	SUCCESS: 'success',
});

export const COURSE_IDS = Object.freeze({
	JOB_INTERVIEW: 1,
	ESL_A1: 2,
	ESL_B1: 3,
	ESL_C1: 4,
	IELTS: 5,
	BUSINESS_LAW: 6,
	BUSINESS_WRITING: 7,
	BUSINESS_MANAGEMENT: 8,
	ENTREPRENEURSHIP_BUSINESS: 9,
	CV_LINKEDIN_WRITING: 10,
	JOB_INTERVIEW_ES: 11,
	CV_LINKEDIN_WRITING_ES: 12,
	CRYPTO_CURRENCY: 13,
	DIGITAL_MARKETING: 14,
	BUSINESS_LAW_ES: 15,
	MICROSOFT_OFFICE: 16,
	CV_LINKEDIN_NEW: 17,
	IELTS_GENERAL: 18,
	TEF: 19,
	TOEFL: 20,
	TOEFL_IBT: 21,
	TCF: 22,
	ESL_A1_GENERAL: 23,
	ESL_B1_GENERAL: 24,
	ESL_C1_GENERAL: 25,
});

export const CONVERSATION_STATUS = Object.freeze({
	ACTIVE: 1,
	CANCELLED: 2,
	RESOLVED: 3,
});

export const MESSAGE_STATUS = Object.freeze({
	SENT: 1,
	SEEN: 2,
});

export const USER_APPLICATION_STATUS = Object.freeze({
	ACTIVE: 1,
	FROZEN: 2,
	1: 'ACTIVE',
	2: 'FROZEN',
});

export const COURSE_STATUS = Object.freeze({
	NEW: 'New',
	NEW_FORM_SENT: 'New-form-sended',
	IN_PROGRESS: 'InProgress',
	COMPLETED: 'Completed',
});

export const FORGOT_MY_PASSWORD_STATUS = Object.freeze({
	Enter_Email: 'Enter_Email',
	Enter_Code: 'Enter_Code',
	Reset_Password: 'Reset_Password',
	Password_Changed: 'Password_Changed',
});

export const ROUTES = Object.freeze({
	HOME: 'https://galwayacademy.com/',
	LOGIN: 'login',
	FORGOT_MY_PASSWORD: 'forgot_my_password',
	REGISTER: 'register',
	UNAUTHORIZED: 'unauthorized',
	PERSONAL_AREA: '/',
	COURSE: 'course',
	MY_COURSE: '/my_course',
	CHAPTER: 'chapter',
	QUIZ: 'quiz',
	REVIEW: '/review',
	IELTSFINALQUIZ: 'ieltsfinalquiz',
	TEF: 'tef',
	TCF: 'tcf',
	TOEFL: 'toefl',
	TOEFL_IBT: 'toeflIBT',
	MANAGEMENT_PANEL: '/management_panel',
	ADVANCED_USER_MANAGEMENT: '/advanced_user_managment',
	ADVANCED_COURSES_MANAGEMENT: '/advanced_courses_mgmt',
	HTML_EDITOR: '/html_editor',
	CONVERSATION: '/conversations',
	VIDEO_PLAYER_PAGE: '/video_player_page',
	IFRAME_VIDEO_PLAYER_PAGE: '/iframe_video_player_page',
	CLASSES_MANAGEMENT: '/classes_managment',
	ABOUT: 'https://galwayacademy.com/courses/',
	SILENT_LOGIN: '/silent_login',
	TESTIMONIALS: '/testimonials',
});

export const LANGUAGES = Object.freeze([
	{
		description: 'English',
		nativeDescription: 'English',
		id: 1,
		translation_id: 25,
		iso: 'EN',
		isRtl: false,
		errorMessage: `An error has happened, please try again in a few minutes.`,
	},
	{
		description: 'Spanish',
		nativeDescription: 'Español',
		id: 2,
		translation_id: 27,
		iso: 'ES',
		isRtl: false,
		errorMessage: `Ha ocurrido un  error, por favor intente de nuevo en unos minutos.`,
	},
	{
		description: 'French',
		nativeDescription: 'Français',
		id: 3,
		translation_id: 34,
		iso: 'FR',
		isRtl: false,
		errorMessage: `Une erreur s’est produite, merci de réessayer dans quelques minutes.`,
	},

	{
		description: 'Arabic',
		nativeDescription: 'عربيه',
		id: 4,
		translation_id: 5,
		iso: 'AR',
		isRtl: true,
		errorMessage: `لقد حدث خطأ ما، نرجو المحاولة مرة أخرى خلال بضعة دقائق.`,
	},
	{
		description: 'Russian',
		nativeDescription: 'Русский',
		id: 5,
		translation_id: 95,
		iso: 'RU',
		isRtl: false,
		errorMessage: `Произошла неизвестная ошибка. Пожалуйста, повторите попытку через несколько минут.`,
	},
	{
		description: 'Turkish',
		nativeDescription: 'Türk',
		id: 6,
		translation_id: 123,
		iso: 'TR',
		isRtl: false,
		errorMessage: `Bir hata oldu, lütfen birkaç dakika sonra tekrar deneyin.`,
	},
]);

export const VALIDATIONS = {
	NOT_EMPTY: { regex: /.+/, error: 'Field is required', errorTranslationKey: 'validations_not_empty_error' },
	NUMBER: { regex: /^[+-]?\d+$/, error: 'Value is illegal', errorTranslationKey: 'validations_illegal_error' },
	POSITIVE_NUMBER: { regex: /^[+]?[1-9]\d*$/, error: 'Value is illegal', errorTranslationKey: 'validations_illegal_error' },
	POSITIVE_NUMBER_WITH_ZERO: { regex: /^[+]?[0-9]\d*$/, error: 'Value is illegal', errorTranslationKey: 'validations_illegal_error' },
	POSITIVE_NUMBER_OR_EMPTY: { regex: /^$|^[+]?[1-9]\d*$/, error: 'Value is illegal', errorTranslationKey: 'validations_illegal_error' },
	ALPHABETIC: { regex: /^[a-zA-Zא-ת]*$/, error: 'Value is illegal', errorTranslationKey: 'validations_illegal_error' },
	ALPHABETIC_WITH_SPACE: { regex: /^[a-zA-Zא-ת\s]*$/, error: 'Value is illegal', errorTranslationKey: 'validations_illegal_error' },
	FLOAT: { regex: /^$|^[+-]?\d+(\.\d+)?$/, error: 'Value is illegal', errorTranslationKey: 'validations_illegal_error' },
	FLOAT_OR_EMPTY: { regex: /^$|^[+]?\d+(\.\d+)?$/, error: 'Value is illegal', errorTranslationKey: 'validations_illegal_error' },
	MAX_LENGTH_3: { regex: /^.{0,3}$/, error: 'Value is too long. max length: 3', errorTranslationKey: 'validations_max_length_3_error' },
	MAX_LENGTH_20: { regex: /^.{0,20}$/, error: 'Value is too long. max length: 20', errorTranslationKey: 'validations_max_length_20_error' },
	MAX_LENGTH_50: { regex: /^.{0,50}$/, error: 'Value is too long. max length: 50', errorTranslationKey: 'validations_max_length_50_error' },
	MAX_LENGTH_100: {
		regex: /^.{0,100}$/,
		error: 'Value is too long. max length: 100',
		errorTranslationKey: 'validations_max_length_100_error',
	},
	MAX_LENGTH_150: {
		regex: /^.{0,150}$/,
		error: 'Value is too long. max length: 150',
		errorTranslationKey: 'validations_max_length_150_error',
	},
	MAX_LENGTH_200: {
		regex: /^.{0,200}$/,
		error: 'Value is too long. max length: 200',
		errorTranslationKey: 'validations_max_length_200_error',
	},
	MAX_LENGTH_250: {
		regex: /^.{0,250}$/,
		error: 'Value is too long. max length: 250',
		errorTranslationKey: 'validations_max_length_250_error',
	},
	EMAIL: {
		//regex: /\S+@\S+\.\S+/
		regex: /^[\w.%+-]+@[\w.-]+\.[A-Za-z]{2,}$/,
		error: 'Illegal email',
		errorTranslationKey: 'validations_email_error',
	},
};

export const EXTERNAL_PAGES = Object.freeze({
	REGISTER: `https://lp.galwayacademy.com/LP/galway/register/`,
});
